import Resources from '@helpers/resources';

export const STUDENT_ASSIGNMENTS_REQUEST = 'STUDENT_ASSIGNMENTS_REQUESTED';
export const STUDENT_ASSIGNMENTS_SUCCESS = 'STUDENT_ASSIGNMENTS_SUCCESS';
export const STUDENT_ASSIGNMENTS_ERROR = 'STUDENT_ASSIGNMENTS_ERROR';

export const RESET_STUDENT_ASSIGNMENTS = 'RESET_STUDENT_ASSIGNMENTS';

export const UPDATE_SORT_DIRECTION_TO_ASC = 'UPDATE_SORT_DIRECTION_TO_ASC';
export const UPDATE_SORT_DIRECTION_TO_DESC = 'UPDATE_SORT_DIRECTION_TO_DESC';

export const SELECT_ALL_ASSIGNMENTS = 'SELECT_ALL_ASSIGNMENTS';
export const UNSELECT_ALL_ASSIGNMENTS = 'UNSELECT_ALL_ASSIGNMENTS';

export const TOGGLE_SELECTED_ASSIGNMENT_IDS = 'TOGGLE_SELECTED_ASSIGNMENT_IDS';

export function fetchStudentAssignmentsRequest() {
  return {
    type: STUDENT_ASSIGNMENTS_REQUEST
  };
}

export function fetchStudentAssignmentsSuccess(payload) {
  return {
    type: STUDENT_ASSIGNMENTS_SUCCESS,
    assignments: payload.assignments
  };
}

export function fetchStudentAssignmentsFailure(errors = []) {
  return {
    type: STUDENT_ASSIGNMENTS_ERROR,
    errors
  };
}

export function toggleAssignmentIds(assignmentId) {
  return {
    type: TOGGLE_SELECTED_ASSIGNMENT_IDS,
    assignmentId
  };
}

export const getStudentAssignments = (studentProfileId, productId) => async (dispatch) => {
  dispatch(fetchStudentAssignmentsRequest());

  try {
    const response = await Resources.assignmentsByStudent
      .get()
      .withParams({ studentProfileId, productId })
      .send();

    if (!response.data) {
      throw response;
    }

    dispatch(fetchStudentAssignmentsSuccess(response.data));
  } catch (err) {
    dispatch(fetchStudentAssignmentsFailure(err));
  }
};

export const resetAssignments = () => async (dispatch) => {
  dispatch({ type: RESET_STUDENT_ASSIGNMENTS });
  dispatch({ type: UNSELECT_ALL_ASSIGNMENTS });
}
